import { SVGProps } from "react";
const MessageSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke="#7D8690"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3 9.732c0 2.995 2.219 5.53 6 6.404V20l5.585-3.78C18.616 15.439 21 12.834 21 9.732 21 6.015 17.585 3 12 3S3 6.015 3 9.732Z"
      clipRule="evenodd"
    />
  </svg>
);
export default MessageSvg;
